



















































import { Vue, Watch, Prop, Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Feedback } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import AmendmentSummary from './Summary.vue';
import ImportButton from '@/components/common/Buttons/ImportButtons.vue';
import { Locales } from "@/i18n/locales";

@Component({
    components: {
        VJsonschemaForm,
        SeriesTable: () => import('@/components/common/SeriesTable/Series.vue'),
        AmendmentSummary,
        ImportButton
    }
})
export default class BudgetRevision extends Vue {
    @State("feedback") feedback!: Feedback;
    @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
    @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
    @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
    @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
    @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number

    @Prop() transactionId: number;
    @Prop() GrantInfo: any;
    @Prop() grantAmendment: any;
    @Prop() schema: any;
    @Prop() data: any;
    @Prop() readOnly: boolean;
    @Prop() indirectCost!: any;
    @Prop() showImportAction: boolean;    
    @Prop() amendmentDtlInfo: any;
    @Prop() userType?: number;
    auditor= _app.UserType.Auditor;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    menuButtons = [
        {
            "key": "budgetData",
            "type": "export",
            "title": "Export",
            "x-file-name": ""
        }
    ];

    budgetValidations: any = [];    
    
    get budgetSchema() {
        if (this.schema && this.schema.properties) {
            return this.schema.properties.applicationBudget;
        } else {
            return {};
        }
    }    

    get options(): any {        
        return {
            disableAll: this.readOnly,
            currency: this.GrantInfo.BudgetCurrency || 'EUR',
            transactionId: this.transactionId,
            //@ts-ignore
            rights: this.$can("manage", "feedback") ? _app.actions.manage : _app.actions.read,
            user: this._userid,
            indirectCost: this.indirectCost,
            entity: _app.entities.grantAmendmentDetail,
            feedbacks: this.feedback.feedbackHeaders,
            actions: {
                createHeader: this.createFeedbackHeader,
                list: this.getFeedbacks,
                resolveFeedback: this.resolveFeedback,
                reopenFeedback: this.reopenFeedback,
                updateFeedback: this.$services.comment.Update
            },
            postAggregateAction: this.calculateVariance,
            locale: this.defaultLocale
        }
    }

    // Calculate variance
    calculateVariance(catId, index, series, data) {
        let item = data[catId][index];

        if (item && item.Total.value >= 0 && item.ApprovedTotal.value != null && item.ApprovedTotal.value != 0) {
            item.variance = (item.Total.value - item.ApprovedTotal.value) / item.ApprovedTotal.value * 100;
        }
    }

    // Set dirty on budget change
    onBudgetChange(e) {
        this.$emit('input', true);
    }

    /** resolve the comment */
    resolveComment(obj: any) {
        this.$services.comment.Resolve(obj);
    }

    exportBudget(e: any) {
        this.$services.grantAmendment.exportToExcel(this.transactionId, `Budget_Modification_${this.transactionId}`, "");
    }
}
